import Utils from '../util'
import type Controls from '../controls'

/**
 * Base class for control modes. Handles the switching on
 * and off of the control mode and calling activation
 * callbacks.
 **/
class ControlMode {
  constructor(
    public controls: Controls,
    protected active = false,
  ) {
    this.controls = controls
    this.active = active

    this.init()

    if (active) {
      Utils.defer(this.activate)
    }

    this.controls.addEventListener('tick', () => {
      if (this.active) {
        this.tick()
      }
    })
  }

  activate = () => {
    if (!this.active) {
      this.active = true
      this.onActivate()
    }
  }

  deactivate = () => {
    if (this.active) {
      this.active = false
      this.onDeactivate()
    }
  }

  // Lifetime methods and events
  init() {
    // 'Called when subclasses are created to avoid super()'
  }

  tick() {
    // 'Called every frame if the mode is active'
  }

  onActivate() {
    // 'Called when the control mode is activated'
  }

  onDeactivate() {
    // 'Called when the control mode is deactivated'
  }
}

export {ControlMode}
